import { useQuery } from "@tanstack/react-query";
import getBoletinsTypes from "Api/boletins/types";

export function useTypesBoletins() {
  return useQuery<string[]>(["types"], getBoletinsTypes);
}
